const LOGIN_FAILURE_CODES = new Set([
  "auth/invalid-credential",
  "auth/wrong-password",
  "auth/user-not-found",
  "auth/invalid-login-credentials",
]);

const SIGNUP_FAILURE_MESSAGES = {
  "auth/email-already-in-use": "An account with this email already exists. Try signing in or reset your password.",
  "auth/invalid-email": "Please enter a valid email address.",
  "auth/weak-password": "Password must be at least 6 characters.",
  "auth/operation-not-allowed": "Email sign-up is not available. Please contact info@yogaretreatsbooking.com.",
};

/**
 * Map Firebase Auth error codes to user-friendly copy (no raw "Firebase: Error (...)" text).
 */
export function friendlyAuthError(err, fallback = "Something went wrong. Please try again.") {
  const code = err?.code || "";
  if (LOGIN_FAILURE_CODES.has(code)) {
    return "Incorrect email or password.";
  }
  if (SIGNUP_FAILURE_MESSAGES[code]) {
    return SIGNUP_FAILURE_MESSAGES[code];
  }
  if (code === "auth/too-many-requests") {
    return "Too many attempts. Please wait a few minutes and try again.";
  }
  if (code === "auth/network-request-failed") {
    return "Network error. Check your connection and try again.";
  }
  if (code === "auth/user-disabled") {
    return "This account has been disabled. Please contact info@yogaretreatsbooking.com.";
  }
  return fallback;
}

export function toAuthError(err, fallback) {
  return new Error(friendlyAuthError(err, fallback));
}
